import script from "./ContentItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentItem.vue?vue&type=script&setup=true&lang=js"

import "./ContentItem.vue?vue&type=style&index=0&id=ce9fce4e&lang=scss"

const __exports__ = script;

export default __exports__